var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 7.79167C4.25 19.9189 14.0811 29.75 26.2083 29.75C26.7555 29.75 27.298 29.73 27.8351 29.6907C28.4515 29.6455 28.7597 29.6229 29.0402 29.4614C29.2726 29.3276 29.4929 29.0905 29.6094 28.849C29.75 28.5574 29.75 28.2173 29.75 27.5371V23.546C29.75 22.974 29.75 22.688 29.6559 22.4428C29.5727 22.2262 29.4376 22.0334 29.2625 21.8812C29.0643 21.709 28.7955 21.6112 28.258 21.4158L23.7149 19.7638C23.0895 19.5363 22.7768 19.4226 22.4801 19.4419C22.2185 19.4589 21.9667 19.5482 21.7528 19.6998C21.5103 19.8718 21.3391 20.1571 20.9967 20.7278L20.9967 20.7278L19.8333 22.6667C16.0794 20.9665 13.036 17.9192 11.3333 14.1667L13.2722 13.0033C13.8429 12.6609 14.1282 12.4897 14.3002 12.2472C14.4518 12.0333 14.5411 11.7815 14.5581 11.5199C14.5774 11.2232 14.4637 10.9105 14.2362 10.2851L14.2362 10.2851L12.5842 5.74205C12.3888 5.2045 12.291 4.93571 12.1188 4.73747C11.9666 4.56236 11.7738 4.42729 11.5572 4.34414C11.312 4.25 11.026 4.25 10.454 4.25H6.46285C5.78266 4.25 5.44257 4.25 5.15097 4.39061C4.90946 4.50706 4.67236 4.72744 4.53858 4.9598C4.37705 5.24034 4.35448 5.54854 4.30934 6.16494C4.27001 6.70205 4.25 7.24452 4.25 7.79167Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.17c1e181dd4aa95bdf68da22b040aa76.svg";
export { ForwardRef as ReactComponent };